module.exports = __webpack_public_path__ + "images/feature/140903_wechat_1-9bbcf57afe73c0140e9930be1a460f13.jpg";